// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"79c45e74","84":"3b7d940e","178":"81c9aac0","378":"308a77f2","535":"1aefd655","633":"22d9939b","723":"3b8fbde3","738":"8f4ed0f3","780":"ec8cebf4","833":"899c6a84","914":"8d6d75d2","945":"266e085f","964":"ccdd3f94"}[chunkId] + ".chunk.js";
};